/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

let fileUpload;
let getResource;
let request;
let simpleRequest;

if (__PRERENDER__) {
  // FIXME::Handle better ajax requests in the backend. Either retrieve the
  // the content directly to embed it or warn the dev not to do this.
  fileUpload = function() {};
  getResource = function() {};
  request = function() {};
  simpleRequest = function() {};
} else {
  const __ = require("language").__;
  const superagent = require("superagent-csrf")(require("superagent"));

  // Set the CSRF token for AJAX requests.
  const csrfToken = AuctionEx.csrfToken;

  fileUpload = (params, callback) => {
    const {
      files,
      url,
      onProgress,
    } = params;

    const req = superagent.post(url).csrf(csrfToken);

    files.forEach(
      file => req.attach("upload", file, file.name),
    );

    if (onProgress) {
      req.on("progress", onProgress);
    }

    req.end((err, response) => {
      if (err) {
        return callback(err);
      }

      callback(null, response.body);
    });
  };

  // TODO: Allow to parametrize more in the ajax request.
  request = (
    {
      data = {},
      type = "GET",
      query = {},
      url = "/",
    },
    callback,
  ) => {
    const buildRequest = superagent(
      type,
      url,
    )
    .query(query)
    .csrf(csrfToken)
    .send(data);

    if (!callback) {
      return buildRequest.then(({body}) => body);
    }

    buildRequest.end((err, res) => {
      if (err) {
        return callback(err);
      }

      callback(null, res.body);
    });
  };

  // Assume POST, "/json/" as the base url and response.errors
  // being the same as an error.
  simpleRequest = (
    {
      data = {},
      endPoint = "",
      query = {},
      type = "POST",
    },
    callback,
  ) => request(
    {
      data,
      query,
      type,
      url: `/json/${endPoint}`,
    },
    callback ? (err, response = {}) => {
      if (err) {
        return callback([__("errors::ajax.fail")]);
      }

      if (response === null) {
        response = {};
      }

      if ("errors" in response) {
        return callback(response.errors);
      }

      callback(null, response);
    } : undefined,
  );

  class Resource {
    constructor({endPoint}) {
      this.endPoint = endPoint;
    }

    async create({data}) {
      return simpleRequest({
        data,
        endPoint: this.endPoint,
        type: "PUT",
      });
    }

    async list() {
      return simpleRequest({
        endPoint: this.endPoint,
        type: "GET",
      });
    }

    async read({id}) {
      return simpleRequest({
        endPoint: `${this.endPoint}/${id}`,
        type: "GET",
      });
    }

    async remove({id}) {
      return simpleRequest({
        endPoint: `${this.endPoint}/${id}`,
        type: "DELETE",
      });
    }

    async replace({data, id}) {
      return simpleRequest({
        data,
        endPoint: `${this.endPoint}/${id}`,
        type: "PUT",
      });
    }

    async update({data, id}) {
      return simpleRequest({
        data,
        endPoint: `${this.endPoint}/${id}`,
        type: "PATCH",
      });
    }
  }

  getResource = params => new Resource(params);
}

module.exports = {
  fileUpload,
  getResource,
  request,
  simpleRequest,
};



// WEBPACK FOOTER //
// ../ajax.js